module.exports = __webpack_public_path__ + "img/zhanli4.13aa62fb.jpg";